import React, { Component } from 'react';
import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Marker = () => {
    return (
        <FontAwesomeIcon
            size="4x"
            color="#82ca9d"
            icon="map-marker-alt"
            style={{transform: 'translate(-50%, -100%)'}}
        />
    )
}

class SimpleMap extends Component {
    static defaultProps = {
        center: {
            lat: 52.0527543,
            lng: 1.1382972
        },
        zoom: 9
    }

     getMapBounds = (map, maps, locations) => {
        const bounds = new maps.LatLngBounds();

        locations.forEach((location) => {
            bounds.extend(
                new maps.LatLng(location.latitude, location.longitude),
            );
        });
        return bounds;
    }

    bindResizeListener = (map, maps, bounds) => {
        maps.event.addDomListenerOnce(map, 'idle', () => {
            maps.event.addDomListener(window, 'resize', () => {
                map.fitBounds(bounds);
            })
        })
    }

    apiIsLoaded = (map, maps, locations) => {
        if (map) {
            const bounds = this.getMapBounds(map, maps, locations);
            map.fitBounds(bounds);
            this.bindResizeListener(map, maps, bounds);
        }
    }

    render() {

        const {
            locations
        } = this.props

        return (
            // Important! Always set the container height explicitly
            <div style={{ height: '100%', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "AIzaSyC0ao5gDqtt3bS7CVFGyDf40UfURQ38p4A" }}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}s
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) => this.apiIsLoaded(map, maps, locations || [])}
                >
                    {locations && locations.map(({latitude, longitude}) => (
                        <Marker
                            lat={latitude}
                            lng={longitude}
                        />
                    ))}

                </GoogleMapReact>
            </div>
        );
    }
}

SimpleMap.propTypes = {
    locations: PropTypes.array
}

export default SimpleMap;